import * as AuthenticationActions from "redux/authentication/authenticationActions";
import * as changePasswordActions from "redux/changePassword/changePasswordActions";
import * as patientListActions from "redux/patients/patientList/patientListActions";
import * as downloadPatientCSVActions from "redux/patients/downloadPatientCSV/downloadPatientCSVActions";
import * as deletePatientActions from "redux/patients/deletePatient/deletePatientActions";
import * as consultationListActions from "redux/consultations/consultationList/consultationListActions";
import * as consultationDetailsActions from "redux/consultations/consultationDetails/consultationDetailsActions";
import * as downloadConsultationCSVActions from "redux/consultations/downloadConsultationCSV/downloadConsultationCSVActions";
import * as getConsentStatementActions from "redux/consentStatement/getConsentStatement/getConsentStatementActions";
import * as postConsentStatementActions from "redux/consentStatement/postConsentStatement/postConsentStatementActions";
import * as settingInformationActions from "redux/setting/general/generalSettingActions";
import * as defaultSettingActions from "redux/setting/default/defaultSettingActions";
import * as verifyPhoneNumberActions from "redux/setting/verifyPhoneNumber/verifyPhoneNumberActions";
import * as patientRegistrationActions from "redux/setting/patientRegistration/patientRegistrationActions";
import * as verifyOTPActions from "redux/setting/verifyOTP/verifyOTPActions";
import * as voiceCallActions from "redux/setting/voiceCall/voiceCallActions";
import * as dashboardInfoActions from "redux/dashboard/dashboardInfo/dashboardInfoActions";
import * as subscribeSuperCityActions from "redux/patients/subscribeSuperCity/subscribeSuperCityActions";
import * as ActivitiesListFilterActions from "redux/messagemanagement/activitiesfilterlist/activitiesFilterListActions";
import * as ClassListFilterActions from "redux/messagemanagement/classfilterlist/classFilterListActions";
import * as GetStudentListActions from "redux/messagemanagement/getstudentlist/getStudentListActions";
import * as GetTemperatureListFilterActions from "redux/messagemanagement/temperaturefilterlist/temperatureFilterListActions";
import * as GetMessageHistoryListActions from "redux/messagemanagement/messagehistory/messageHistoryListActions";
import * as GetMessageHistoryDetailActions from "redux/messagemanagement/messagehistorydetail/messageHistoryDetailActions";
import * as GetAttendanceFilterListActions from "redux/messagemanagement/attendancefilterlist/attendanceFilterListActions";
import * as SendMessageActions from "redux/messagemanagement/sendmessage/sendMessageActions";
import * as searchConditionActions from "redux/messagemanagement/searchCondition/searchConditionActions";
import * as readHistoryListActions from "redux/messagemanagement/readHistory/readHistoryListActions";
import * as pushNotificationActions from "redux/messagemanagement/pushNotification/pushNotificationActions";
import * as updateMessageDeliveryActions from "redux/messagemanagement/updateMessage/updateMessageActions";
import * as deleteMessageDeliveryActions from "redux/messagemanagement/deleteMessage/deleteMessageActions";
import * as resendMessageActions from "redux/messagemanagement/resendMessage/resendMessageActions";
import * as ForgotPasswordActions from "redux/forgotpassword/forgotpasswordActions";
import * as ResetPasswordActions from "redux/resetpassword/resetpasswordActions";
import * as VerifyResetPasswordTokenActions from "redux/verifyResetPasswordToken/verifyResetPasswordTokenActions";

export const ActionCreators = Object.assign({}, { ...AuthenticationActions });

export const ChangePasswordActionCreators = Object.assign(
  {},
  { ...changePasswordActions }
);

export const GetPatientsActionCreators = Object.assign(
  {},
  { ...patientListActions }
);

export const DownloadPatientsCSVActionCreators = Object.assign(
  {},
  { ...downloadPatientCSVActions }
);

export const DeletePatientActionCreators = Object.assign(
  {},
  { ...deletePatientActions }
);

export const GetConsultationsActionCreators = Object.assign(
  {},
  { ...consultationListActions }
);

export const GetConsultationDetailsActionCreators = Object.assign(
  {},
  { ...consultationDetailsActions }
);

export const DownloadConsultationCSVActionCreators = Object.assign(
  {},
  { ...downloadConsultationCSVActions }
);

export const GetConsentStatementActionCreators = Object.assign(
  {},
  { ...getConsentStatementActions }
);

export const PostConsentStatementActionCreators = Object.assign(
  {},
  { ...postConsentStatementActions }
);

export const SettingInformationActionCreators = Object.assign(
  {},
  { ...settingInformationActions }
);

export const DefaultSettingActionCreators = Object.assign(
  {},
  { ...defaultSettingActions }
);

export const VerifyPhoneNumberActionCreators = Object.assign(
  {},
  { ...verifyPhoneNumberActions }
);

export const PatientRegistrationActionCreators = Object.assign(
  {},
  { ...patientRegistrationActions }
);

export const VerifyOTPActionCreators = Object.assign(
  {},
  { ...verifyOTPActions }
);

export const VoiceCallActionCreators = Object.assign(
  {},
  { ...voiceCallActions }
);

export const GetDashboardInfoActionCreators = Object.assign(
  {},
  { ...dashboardInfoActions }
);

export const SubscribeSuperCityActionCreators = Object.assign(
  {},
  { ...subscribeSuperCityActions }
);

export const ActivitiesListFilterActionCreators = Object.assign(
  {},
  { ...ActivitiesListFilterActions }
);

export const ClassListFilterActionCreators = Object.assign(
  {},
  { ...ClassListFilterActions }
);

export const GetStudentActionCreators = Object.assign(
  {},
  { ...GetStudentListActions }
);

export const GetTemperatureListFilterActionCreators = Object.assign(
  {},
  { ...GetTemperatureListFilterActions }
);

export const GetMessageHistoryListFilterActionCreators = Object.assign(
  {},
  { ...GetMessageHistoryListActions }
);

export const GetMessageHistoryDetailActionCreators = Object.assign(
  {},
  { ...GetMessageHistoryDetailActions }
);

export const GetAttendanceListFilterActionCreators = Object.assign(
  {},
  { ...GetAttendanceFilterListActions }
);

export const SendMessageActionCreators = Object.assign(
  {},
  { ...SendMessageActions }
);

export const SearchConditionActionCreators = Object.assign(
  {},
  {
    ...searchConditionActions,
  }
);

export const GetReadHistoryActionCreators = Object.assign(
  {},
  {
    ...readHistoryListActions,
  }
);

export const pushNotificationActionCreators = Object.assign(
  {},
  {
    ...pushNotificationActions,
  }
);

export const UpdateMessageActionCreators = Object.assign(
  {},
  {
    ...updateMessageDeliveryActions,
  }
);

export const DeleteMessageActionCreators = Object.assign(
  {},
  {
    ...deleteMessageDeliveryActions,
  }
);

export const ResendMessageActionCreators = Object.assign(
  {},
  {
    ...resendMessageActions,
  }
);

export const ForgotPasswordActionCreators = Object.assign(
  {},
  { ...ForgotPasswordActions }
);
export const ResetPasswordActionCreators = Object.assign(
  {},
  { ...ResetPasswordActions }
);
export const VerifyResetPasswordTokenActionCreators = Object.assign(
  {},
  { ...VerifyResetPasswordTokenActions }
);
